const jsonEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export default jsonEqual;
